// React
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { OfficesInjection } from '../../containers/officesInjection';

// View
import { OfficesFormPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import '../../../../utils/validation/cpfMethodValidation';
import { APIClient } from '../../../../helpers/api_helper';

export const OfficesForm = () => {
  const [officesById, setOfficesById] = useState(null);

  const { createOffices, updateOffices } = OfficesInjection();

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();
  const { loadingWithTime } = useLoading();

  const getOfficesById = async (id) => {
    const offices = await api.get(`/register/office/${id}`);

    if (offices) {
      setOfficesById(offices);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: officesById ? officesById.name : '',
      cnpjInput: officesById ? officesById.cnpj : '',
      emailInput: officesById ? officesById.email : '',
      phoneInput: officesById ? officesById.phone1 : '',
      phone2Input: officesById ? officesById.phone2 : '',
      zipInput: officesById ? officesById.zipcode : '',
      streetInput: officesById ? officesById.address1 : '',
      numberInput: officesById ? officesById.address_num : '',
      address2Input: officesById ? officesById.address2 : '',
      neighboorhoodInput: officesById ? officesById.district : '',
      cityInput: officesById
        ? { value: officesById.city_id, label: officesById.city_name }
        : '',
      isActive: officesById ? officesById.active : true,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      cnpjInput: Yup.string().cnpjType('Digite um CNPJ válido').nullable(),
      emailInput: Yup.string().email('Digite um email válido').nullable(),
      phoneInput: Yup.string().nullable(),
      phone2Input: Yup.string().nullable(),
      zipInput: Yup.string().nullable(),
      streetInput: Yup.string().nullable(),
      numberInput: Yup.string().nullable(),
      address2Input: Yup.string().nullable(),
      neighboorhoodInput: Yup.string().nullable(),
      cityInput: Yup.object().nullable(),
      isActive: Yup.boolean().nullable(),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        cnpj: values.cnpjInput || null,
        email: values.emailInput || null,
        phone1: values.phoneInput || null,
        phone2: values.phone2Input || null,
        zipcode: values.zipInput || null,
        address1: values.streetInput || null,
        address_num: values.numberInput || null,
        address2: values.address2Input || null,
        district: values.neighboorhoodInput || null,
        city_id: values.cityInput.value || null,
        active: values.isActive || false,
      };
      loadingWithTime(1000);
      if (officesById) {
        updateOffices(officesById.id, valuesToSubmit);
        history.goBack();
      } else {
        createOffices(valuesToSubmit);
        history.goBack();
      }
    },
  });

  useEffect(() => {
    if (id) {
      getOfficesById(id);
    }
  }, [id]);

  return (
    <OfficesFormPage
      id={id}
      history={history}
      validation={validation}
      updatedAt={officesById ? officesById.last_update : ''}
    />
  );
};
